// Vollea — Forgot password 3-step flow
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { IoChevronBack } from "react-icons/io5";
import { Btn, Logo } from "../components/ui-vollea";
import { api } from "../lib/api";
import { C, SP, R } from "../lib/theme";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [stage, setStage] = useState(1);
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [devCode, setDevCode] = useState(null);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const label = { color: C.textMuted, fontSize: 11, fontWeight: 600, letterSpacing: 1, marginBottom: 6, marginTop: SP.md, textTransform: "uppercase", display: "block" };
  const input = { width: "100%", background: C.surface, borderRadius: R.md, border: `1px solid ${C.border}`, color: C.text, padding: `0 ${SP.lg}px`, height: 52, fontSize: 15, outline: "none" };

  const requestCode = async (e) => {
    e?.preventDefault?.();
    setErr(""); setMsg(""); setBusy(true);
    try {
      const data = await api.post("/auth/request-reset", { email });
      setMsg(data.message);
      if (data.dev_code) setDevCode(data.dev_code);
      setStage(2);
    } catch (e) { setErr(e.message); }
    finally { setBusy(false); }
  };

  const resetPassword = async (e) => {
    e?.preventDefault?.();
    setErr(""); setBusy(true);
    try {
      await api.post("/auth/reset-password", { email, code, new_password: newPassword });
      setStage(3);
    } catch (e) { setErr(e.message); }
    finally { setBusy(false); }
  };

  return (
    <div style={{ minHeight: "100vh", background: C.bg, padding: `${SP.lg}px ${SP.lg}px 40px` }}>
      <button onClick={() => navigate(-1)} data-testid="forgot-back" style={{ width: 40, height: 40, color: C.text }}>
        <IoChevronBack size={26} />
      </button>
      <div style={{ display: "flex", justifyContent: "center", margin: `${SP.xl}px 0` }}><Logo size={30} /></div>

      {stage === 1 && (
        <form onSubmit={requestCode}>
          <h1 style={{ color: C.text, fontWeight: 700, fontSize: 26, margin: 0 }}>Forgot password</h1>
          <p style={{ color: C.textMuted, fontSize: 14, marginTop: 4, marginBottom: SP.xl }}>We'll email you a 6-digit reset code.</p>
          <label style={label}>Email</label>
          <input data-testid="forgot-email-input" style={input} type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          {err ? <p style={{ color: C.error, marginTop: SP.md, fontSize: 13 }}>{err}</p> : null}
          <div style={{ height: SP.lg }} />
          <Btn label="Send reset code" loading={busy} onClick={requestCode} testid="forgot-request-button" type="submit" />
        </form>
      )}

      {stage === 2 && (
        <form onSubmit={resetPassword}>
          <h1 style={{ color: C.text, fontWeight: 700, fontSize: 26, margin: 0 }}>Enter code</h1>
          <p style={{ color: C.textMuted, fontSize: 14, marginTop: 4, marginBottom: SP.xl }}>{msg}</p>
          {devCode && (
            <div style={{ background: C.limeTint, border: `1px solid ${C.lime}`, padding: SP.md, borderRadius: R.md, marginBottom: SP.lg }}>
              <div style={{ color: C.lime, fontSize: 11, fontWeight: 700, letterSpacing: 1 }}>DEV CODE</div>
              <div data-testid="dev-code-display" style={{ color: C.lime, fontSize: 24, fontWeight: 700, fontFamily: "monospace", letterSpacing: 4, marginTop: 4 }}>{devCode}</div>
            </div>
          )}
          <label style={label}>6-digit code</label>
          <input
            data-testid="forgot-code-input"
            style={{ ...input, textAlign: "center", letterSpacing: 8, fontFamily: "monospace", fontSize: 22 }}
            value={code}
            onChange={(e) => setCode(e.target.value.replace(/\D/g, "").slice(0, 6))}
            maxLength={6}
            required
          />
          <label style={label}>New password (min 6)</label>
          <input data-testid="forgot-newpw-input" style={input} type="password" minLength={6} value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required />
          {err ? <p style={{ color: C.error, marginTop: SP.md, fontSize: 13 }}>{err}</p> : null}
          <div style={{ height: SP.lg }} />
          <Btn label="Reset password" loading={busy} onClick={resetPassword} testid="forgot-reset-button" type="submit" />
          <button type="button" onClick={() => setStage(1)} style={{ color: C.textMuted, fontSize: 13, marginTop: SP.lg, width: "100%" }}>Use a different email</button>
        </form>
      )}

      {stage === 3 && (
        <div>
          <h1 style={{ color: C.text, fontWeight: 700, fontSize: 26, margin: 0 }}>All set</h1>
          <p style={{ color: C.textMuted, fontSize: 14, marginTop: 4, marginBottom: SP.xl }}>You can now log in with your new password.</p>
          <Btn label="Back to login" onClick={() => navigate("/login")} testid="forgot-back-to-login" />
        </div>
      )}
    </div>
  );
}
